import { combineReducers } from 'redux';
import { Bike_management } from './bike_models.reducers';
import { Lead_o_matic_update } from '../../../Lead-o-matic_update/redux/reducers/leadomatic_config.reducers';
import { Price_o_matic_update } from '../../../Price-o-matic_update/redux/reducers/priceomatic_config.reducers';
import { Manage_affiliates } from '../../../Manage_affiliates/redux/reducers/affiliates_list.reducers';
// import { leadomatic_web_jobs } from "../../../Lead-o-matic/redux/reducers/leadomatic_web_jobs.reducers";
// import { priceomatic_job_list } from "../../../Price-o-matic/redux/reducers/priceomatic_job_list";

export const PlatformManagement = combineReducers({
    Bike_management,
    Lead_o_matic_update,
    Price_o_matic_update,
    Manage_affiliates,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/reducers/index.js